<template>
    <div class="user">
        <div class="user-top">
            <div class="con">
                <div class="info clearfix">
                    <button @click="$router.push('/vip/buy')" v-if="userInfo.role == 1">开通会员</button>
                    <button @click="showVip" v-if="userInfo.role==2 || (userInfo.role == 3 && userInfo.leader)">续费会员</button>
                    <div class="account">
                        <img src="@/assets/img/user/head_img.png" alt="">
                        <div style="height:70px;display: flex;justify-content: center;align-items: flex-start;flex-direction: column;">
                            <span> {{userInfo.nickName}}</span>
                            <p style="white-space: nowrap;" v-if="userInfo.role != 1">到期时间： {{userInfo.expirationTime}}</p>
                        </div>
                    </div>
                </div>
                <div class="show-list">
                    <div v-for="(item,index) in showList" :key="index" class="item">
                        <img :src="item.url" alt="">
                        <span>{{item.title}}</span><br>
                        <em>{{item.desc}}</em>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="section_l">
                <ul class="user-menu">
                    <li v-for="(item) in navList" :key="item.index" v-show="!((item.index==2&&(userInfo.role==2||userInfo.role==3&&userInfo.leader)) || (item.index==3&&(userInfo.role!=3 ||(userInfo.role==3 && !userInfo.leader))))">
                        <router-link :to="item.router" active-class="activeClass">
                            <img :src="item.activeUrl" v-if="curRouter==item.router">
                            <img :src="item.url" v-else>
                            {{ item.name }}
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="section_r">
                <div class="loaction" v-if="curName != '我的发票'">{{curName}}</div>
                <router-view></router-view>
            </div>
        </div>
        <conversation></conversation>
        <Openvip ref="renewal" v-show="isShow" />
    </div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import Openvip from "@/components/Openvip";
import Conversation from "@/components/Conversation";
export default {
    components: {
        Openvip,
        Conversation
    },
    computed: {
        ...mapGetters({
            userInfo: "getUser"
        })
    },
    data() {
        return {
            isShow: false,
            curRouter: this.$route.path,
            curName: this.$route.name,
            showList: [{
                url: require('@/assets/img/user/data.png'),
                title: '海量数据',
                desc: '海量企业数据任您查询筛选'
            },
            {
                url: require('@/assets/img/user/chart.png'),
                title: '企业动态随时查询',
                desc: '关注企业信息，动态更新及时提醒'
            },
            {
                url: require('@/assets/img/user/account.png'),
                title: '主账号管理',
                desc: '主账号可修改子账号，解决人员变动问题'
            },
            {
                url: require('@/assets/img/user/buy.png'),
                title: '多人享优惠',
                desc: '5人起购，套餐价格更实惠'
            },
            ],
            navList: [{
                index: 0,
                name: "我的关注",
                router: "/user/care",
                url: require('@/assets/img/user/care.png'),
                activeUrl: require('@/assets/img/user/care_b.png')
            },
            {
                index: 1,
                name: "浏览历史",
                router: "/user/history",
                url: require('@/assets/img/user/history.png'),
                activeUrl: require('@/assets/img/user/history_b.png')
            },
            // {
            // index:2,
            //     name: "我的企业",
            //     router: "/user/company",
            //     url: require('@/assets/img/user/company.png'),
            //     activeUrl: require('@/assets/img/user/company_b.png')
            // },
            {
                index: 3,
                name: "我的团队",
                router: "/user/team",
                url: require('@/assets/img/user/team.png'),
                activeUrl: require('@/assets/img/user/team_b.png')
            },
            {
                index: 4,
                name: "购买记录",
                router: "/user/buy",
                url: require('@/assets/img/user/record.png'),
                activeUrl: require('@/assets/img/user/record_b.png')
            },
                // {
                // index:5,
                //     name: "我的发票",
                //     router: "/user/invoice",
                //     url: require('@/assets/img/user/invoice.png'),
                //     activeUrl: require('@/assets/img/user/invoice_b.png')
                // }
            ]
        };
    },
    watch: {
        '$route': function (newVal, oldVal) {
            this.curRouter = newVal.path;
            this.curName = newVal.name
        }
    },
    mounted() { },
    methods: {
        // showVip() {
        //     this.$http.get("/app/order/singlePrice").then((res) => {
        //         if (res.data.code == 0) {
        //             this.datalist = res.data.data;
        //             if (this.userInfo.role == 3) {
        //                 this.$http.get("/app/company/invitationCode").then(res => {
        //                     if (res.data.code == 0) {
        //                         this.isShow = true;
        //                         let json = {
        //                             memberType: 2, //会员类型（1个人 2企业）
        //                             payUse: 2, //订单类型（1 新开 2续费）
        //                             num: res.data.data.count, //人数
        //                             memberTypearry: this.datalist.member, //选中的会员价格数组
        //                             index: 0, //选中的索引值
        //                             end: this.userInfo.expirationTime,
        //                         };
        //                         this.$refs.renewal.getSrcList(json);
        //                     }
        //                 })
        //             } else {
        //                 this.isShow = true;
        //                 this.datalist = res.data.data;
        //                 let json = {
        //                     memberType: 1, //会员类型（1个人 2企业）
        //                     payUse: 2, //订单类型（1 新开 2续费）
        //                     num: 1, //人数
        //                     memberTypearry: this.datalist.single, //选中的会员价格数组
        //                     index: 0, //选中的索引值
        //                     end: this.userInfo.expirationTime,
        //                 };
        //                 this.$refs.renewal.getSrcList(json);
        //             }

        //         }

        //     });
        // },
          showVip() {
            this.$http.get("/app/order/singlePriceNew").then((res) => {
                this.priceList = []
                this.isShow = true;
                this.datalist = res.data.data;
                for (var d in this.datalist) {
                    this.priceList.push({
                        month: d,
                        price: this.datalist[d]
                    });
                }
                console.log(this.datalist, 999)
                let json = {
                    memberType: 1, //会员类型（1个人 2企业）
                    payUse: 2, //订单类型（1 新开 2续费）
                    num: 1, //人数
                    memberTypearry: this.priceList, //选中的会员价格数组
                    index: 0, //选中的索引值
                    end: this.userInfo.expirationTime,
                };
                this.$refs.renewal.getSrcList(json);




            });
        },
        closeVip() { //子组件也调用
            this.isShow = false;
        },
    },
};
</script>

<style lang="less" scoped>
.user {
  background-color: #f5f5f5;
  padding-bottom: 30px;

  .user-top {
    width: 100%;
    margin-bottom: 20px;
    height: 270px;
    background: url("../../assets/img/user/bg.jpg") bottom no-repeat;

    .con {
      width: 1200px;
      margin: 0 auto;
      color: #fff;
      font-size: 14px;

      .info {
        padding: 50px 60px 0 40px;

        button {
          float: right;
          width: 160px;
          height: 44px;
          background: #3779ff;
          border-radius: 4px;
          color: #fff;
          font-size: 16px;
        }

        .account {
          line-height: 30px;
          width: 500px;

          img {
            float: left;
            margin-right: 20px;
          }

          span {
            font-size: 18px;
            display: inline-block;
            margin-top: 5px;
          }
        }
      }

      .show-list {
        display: flex;
        justify-content: space-between;
        margin-top: 66px;

        .item {
          flex-grow: 1;
          padding-left: 30px;
          line-height: 22px;

          img {
            float: left;
            margin-top: 5px;
            margin-right: 10px;
          }

          span {
            font-size: 14px;
            font-weight: bold;
            display: inline-block;
          }

          em {
            font-size: 12px;
            font-style: normal;
            opacity: 0.7;
          }
        }
      }
    }
  }

  .section {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    min-height: 310px;

    .section_l {
      width: 260px;
      font-size: 14px;

      .user-menu {
        li {
          border-bottom: #eeeeee 1px solid;

          a {
            display: block;
            background: #fff url("../../assets/img/user/right.png") 230px center
              no-repeat;
            line-height: 50px;
            padding: 0 20px;

            &:hover {
              background-color: #eff4ff;
            }

            &.activeClass {
              background-color: #eff4ff;
              color: #3779ff;
            }

            img {
              display: inline-block;
              margin-right: 8px;
              vertical-align: middle;
            }
          }
        }
      }
    }

    .section_r {
      width: 920px;

      .loaction {
        line-height: 60px;
        border-bottom: #eeeeee 1px solid;
        padding-left: 35px;
        color: #333;
        font-weight: bold;
        position: relative;
        background-color: #fff;

        &::after {
          position: absolute;
          content: "";
          width: 3px;
          height: 16px;
          background: #3779ff;
          left: 20px;
          top: 22px;
        }
      }
    }
  }
}
</style>
